import { callApi } from "../../../../_services/Arya2.0/Finance/LandingPage/api";

export const getAllChildren = async (urlParamString) => {
  return callApi(`/all-child/${urlParamString ? urlParamString : ""}`, "GET");
};

export const handleChildLogin = async (payload) => {
  return callApi(`/v2/child-login`, "POST", payload);
};
export const handleSwitchProfile = async (payload) => {
  return callApi(`/v4/switch-profile`, "POST", payload);
};
